import { Outlet, Navigate, NavLink } from 'react-router-dom'
import { useTheme } from '../context/ThemeProvider'

import useLogout from '../hooks/useLogout'
import Footer from '../components/Footer'
import useAuth from '../hooks/useAuth'
import moment from 'moment'

import InfoMessage from '../components/InfoMessage'
import Loader from '../components/Loader'

function AuthLayout() {
  const { auth, showLoader, showInfo } = useAuth()
  const { hostname } = window.location

  const theme = useTheme()
  
  const style = { backgroundColor: '#02ADAD', color: '#02ADAD', logo: theme.logo, footer: theme.footer }

  const logout = useLogout()
  const navClasses =
    'py-1 px-3 rounded-md items-center hover:bg-[#00ADAD] hover:text-white text-center'
  const accountSelect = () => {
    ;<Navigate to="account-select" />
  }
  const guideLink = () => 
    {
      let guide = 'https://kisdigital.s3.eu-west-2.amazonaws.com/hub/SAS+-+OH+Guide.pdf';
      if (window.location.href.includes('schoolsmutual'))
        {
          guide = 'https://kisdigital.s3.eu-west-2.amazonaws.com/hub/Schools+Mutual+-+OH+Guide.pdf';
        }
        return guide;
      }
  return (
    <div className="bg-slate-50/50 w-full">
      {showLoader && <Loader />}
      {showInfo?.message && <InfoMessage />}
      <div className="absolute w-full">
        {auth.token ? (
          <div className="h-[50px] sm:h-[60px] bg-white shadow z-10 relative flex justify-between items-center px-4 md:px-8">
            <h2
              className="text-base sm:text-xl font-bold "
              style={{ color: style.color }}
            >
              {hostname.includes('mutual') ? (
                  <NavLink to={`/dashboard`}>Schools Mutual</NavLink>
                ) : (
                  <NavLink to={`/dashboard`}>Schools Advisory Service</NavLink>
                )
              }
            </h2>
            {/* if logged in */}
            <div className="flex space-x-4 items-center">
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  isActive
                    ? 'bg-[#2babe0] text-white ' +
                      navClasses +
                      ' pointer-events-none'
                    : navClasses + ''
                }
              >
                Dashboard
              </NavLink>
              {auth?.schools?.length > 1 && (
                <NavLink
                  to="account-select"
                  className={({ isActive }) =>
                    isActive
                      ? 'bg-[#2babe0] ' +
                        navClasses +
                        ' pointer-events-none text-white'
                      : navClasses + ' '
                  }
                >
                  <span className="w-[300px]">Switch School</span>
                </NavLink>
              )}
               <a
                href={guideLink()} 
                target="_blank"
                rel="noopener noreferrer"
                className={navClasses + ' '}>
                <span className="w-[300px]">View Guide</span>
              </a>
              {/* <NavLink to={`/users/${auth.user.contact_id}/account-settings`} className={({ isActive }) =>
                isActive
                  ? 'bg-[#2babe0] ' + navClasses + ' pointer-events-none text-white'
                  : navClasses + ' '
              }>
                  <span className='w-[300px]'>Account Settings</span>
            </NavLink> */}
              <p
                className="text-slate-800 text-sm sm:text-base cursor-pointer"
                onClick={logout}
              >
                Logout
              </p>
            </div>
          </div>
        ) : null}
        {moment().isAfter('2024-12-23') && moment().isBefore('2025-01-02') && (
          <div className="w-full bg-amber-300 p-4">
            <div className="ml-3">
              <p className="text-sm text-center font-medium text-amber-800">
                <strong>Please Note:</strong> Any PPQs requested from 23rd December 2024 until 1st January 2025 won't be actioned until 2nd January 2025.
              </p>
            </div>
          </div>
        )}
        <div
          className="h-[150px] sm:h-[80px] z-[9] relative w-full"
          style={{ backgroundColor: style.backgroundColor }}
        ></div>
        <div
          className="w-full h-[283px] sm:block hidden"
          style={{ backgroundImage: 'url(/images/wave-oh.png)' }}
        >
          &nbsp;
        </div>
      </div>

      <div className="relative pt-[90px] sm:pt-28">
        <div className="flex items-center flex-col z-10 relative px-4 min-h-[650px] w-full">
          <Outlet />
        </div>
        <Footer theme={theme} />
      </div>
    </div>
  )
}

export default AuthLayout
